<template>
  <div class="feature parking notranslate">
    <h1 class="boxTitle mb15 toUppercase">{{locale.parking_info}}</h1>
    <div v-if="active">
      <div v-if="regist">
        <button v-if="list && list.length < limit" type="button" class="btnAdd" @click="openLayer">{{locale.car_number_regist}}</button>
        <p class="message mb15 colorGrey">{{limitMessage}}</p>
      </div>
      <div v-if="list && list.length" class="parkingList">
        <div v-for="(item, index) in list"
          :key="index"
          class="parkingInfo">
          <div class="infoContent">
            <dl v-if="item.carNo">
              <dt>{{locale.car_number}}</dt>
              <dd>{{item.carNo}}</dd>
            </dl>
            <dl v-if="display.area && (item.floor || item.area)">
              <dt>{{locale.parking_area}}</dt>
              <dd>
                <span v-if="item.floor" class="areaInfo">{{ item.floor }}<i class="colorGrey">F</i></span>
                <span v-if="item.area" class="areaInfo">{{ item.area }}</span>
              </dd>
            </dl>
            <dl v-if="display.entrance && item.in">
              <dt>{{locale.entrance_time}}</dt>
              <dd>{{item.in}}</dd>
            </dl>
            <dl v-if="display.depature && item.out">
              <dt>{{locale.depature_time}}</dt>
              <dd>{{ item.out }}</dd>
            </dl>
          </div>
          <div class="infoBtns" v-if="regist">
            <!-- v-if="!accessDenied" 임시 차량번호 미노출 -->
            <button v-if="!accessDenied && canUpdate" type="button" class="btn btnWhite" @click="openEditLayer(item)">{{ locale.car_number_edit }}</button>
            <button v-if="canDelete" type="button" class="btn btnRed" @click="toastDeleteParking(item)">{{ locale.car_number_delete }}</button>
          </div>
        </div>
      </div>
      <div v-else-if="!(auth && auth.result)" class="noData">{{locale.invalid_key}}</div>
      <div v-else class="noData">{{locale.parking_nodata}}</div>
    </div>
    <div v-else-if="errStatus" class="noData">{{ locale[errStatus] }}</div>
    <div v-else class="noData">{{locale.alert_not_support}}</div>
    <!-- parking layer -->
    <div v-if="setLayer" class="layer">
      <button type="button" class="btnClose" @click="cancelLayer"></button>
      <div class="inner">
        <h1 class="layerTitle">{{locale.car_number_regist}}</h1>
        <div class="inputBox mb5">
          <input type="text" class="input" :class="{passed: validateCarNo === 'pass'}" placeholder="12가1234" v-model="carNo" @input="checkCarNoPattern('regist')" @keypress.enter="saveCarNo">
          <i v-if="validateCarNo === 'pass'" class="pass"></i>
          <p v-if="validateCarNo === 'pattern'" class="validateMessage colorRed">{{locale.message_car_number_pattern}}</p>
        </div>
        <div class="btns">
          <button type="button" class="btn btnWhite" @click="cancelLayer">{{ locale.cancel }}</button>
          <button type="button" class="btn" @click="saveCarNo">{{ locale.save }}</button>
        </div>
      </div>
    </div>
    <!-- //parking layer -->
    <!-- parking edit layer -->
    <div v-if="setEditLayer" class="layer">
      <button type="button" class="btnClose" @click="closeEditLayer"></button>
      <div class="inner">
        <h1 class="layerTitle">{{ locale.car_number_edit }}</h1>
        <div class="inputBox mb5">
          <input type="text" class="input" :class="{passed: validateEditCarNo === 'pass'}" placeholder="12가1234" v-model="editCarNo" @input="checkCarNoPattern('edit')" @keypress.enter="saveEditCarNo">
          <i v-if="validateEditCarNo === 'pass'" class="pass"></i>
          <p v-if="validateEditCarNo === 'pattern'" class="validateMessage colorRed">{{locale.message_car_number_pattern}}</p>
        </div>
        <div class="btns">
          <button type="button" class="btn btnWhite" @click="closeEditLayer">{{ locale.cancel }}</button>
          <button type="button" class="btn" @click="saveEditCarNo">{{ locale.save }}</button>
        </div>
      </div>
    </div>
    <!-- //parking edit layer -->
    <div v-if="toastList">
      <Toast v-for="toast in toastList"
        :locale="locale"
        :key="toast.id"
        :toast="toast"
        @confirm="toastConfirm" />
    </div>
  </div>
</template>

<script>
import { DateTime } from 'luxon'
import moment from 'moment-timezone'
// import regExp from '@/common/regExp'
import UNIQUE from '@/common/unique'
import Toast from '@/components/Util/Toast'

export default {
  name: 'Parking',
  props: [
    'locale',
    'isPublic',
    'lang',
    'ln'
  ],
  components: {
    Toast
  },
  computed: {
    timezone () {
      return this.$store.state.siteInfo.timezoneId || ''
    },
    format () {
      const setting = this.$store.state.common.setting
      const date = setting.dateFormat[setting.dateformatDefault]
      const time = 'HH:mm:ss'
      return `${date} ${time}`
    },
    validateCarNo () {
      const carNo = this.carNo
      const pattern = /^\d{2,3}[가-힣]\d{4}$/
      const validEmpty = carNo.length > 0
      const validPattern = pattern.test(carNo)
      return !validEmpty
        ? 'empty'
        : (validPattern ? 'pass' : 'pattern')
    },
    limitMessage () {
      const limit = this.limit
      return this.locale.message_car_limit.replace('{var}', limit)
    },
    validateEditCarNo () {
      const carNo = this.editCarNo
      const pattern = /^\d{2,3}[가-힣]\d{4}$/
      const validEmpty = carNo.length > 0
      const validPattern = pattern.test(carNo)
      return !validEmpty
        ? 'empty'
        : (validPattern ? 'pass' : 'pattern')
    },
    canUpdate () {
      if (!this.parkingSetting || !this.guestUserInfo) return false
      const status = this.guestUserInfo.status
      const setting = status === 'in' ? this.parkingSetting.checkIn : (status === 'book' ? this.parkingSetting.preArrive : null)
      return !!(setting && setting.updateParking)
    },
    canDelete () {
      if (!this.parkingSetting || !this.guestUserInfo) return false
      const status = this.guestUserInfo.status
      const setting = status === 'in' ? this.parkingSetting.checkIn : (status === 'book' ? this.parkingSetting.preArrive : null)
      return !!(setting && setting.cancelParking)
    }
  },
  async mounted () {
    const isActive = await this.getFeatureParking()
    this.track()
    if (isActive) {
      this.active = true
      await this.$store.dispatch('authentication/getOtaKey')
      this.setAuthentication()
      await this.$store.dispatch('guest/getUserInfo').then(() => {
        this.guestUserInfo = this.$store.getters['guest/getGuestUserInfo']
      })
      this.getParking()
      this.getParkingSetting()
    } else {
      alert(this.locale.alert_not_support)
    }
  },
  data () {
    return {
      active: false,
      errStatus: null,
      limit: 2,
      list: [],
      setLayer: false,
      carNo: '',
      auth: null,
      toastList: [],
      regist: false,
      setEditLayer: false,
      editCarNo: '',
      editTarget: null,
      display: {
        area: true,
        entrance: true,
        depature: true
      },
      accessDenied: false, // OTA 만료 여부
      parkingSetting: null, // editor 주차 설정정보
      guestUserInfo: null // 게스트 정보
    }
  },
  methods: {
    parkingApiError (res) {
      const result = res.message
      const code = result && result.code
      let message = 'alert_system_error'
      if (code === 301) {
        message = 'already_parking'
      } else if (code === 302) {
        message = 'not_found_car'
      } else if (code === 303) {
        message = 'already_discount'
      } else if (code === 304) {
        message = 'invalid_car_number'
      } else if (code === 371) {
        message = 'access_denied'
      } else if (code === 406) {
        message = 'not_found_data'
      } else if (code === 501) {
        message = 'response_fail'
      } else if (code === 502) {
        message = 'api_call_fail'
      }
      this.addToast('cancelSetLayer', 'alert', this.locale[message])
      this.errStatus = message
    },
    track () {
      const site = this.$store.state.authentication.site
      const routerPath = this.$route.path
      const path = `${site}${routerPath}`
      this.$gtag.pageview({
        page_path: path,
        page_title: 'parking'
      })
    },
    addToast (trigger, type, message, otherData) {
      const id = UNIQUE.mid()
      const toast = {
        id: id,
        type: type,
        trigger: trigger,
        message: message,
        ...otherData
      }
      this.toastList.push(toast)
    },
    delToast (id) {
      this.toastList = id ? this.toastList.filter(x => x.id !== id) : []
    },
    toastConfirm (data) {
      const trigger = this.toastList.find(x => x.id === data.id) ? this.toastList.find(x => x.id === data.id).trigger : null
      if (!data.isConfirm) {
        this.delToast(data.id)
      } else {
        if (trigger) {
          if (trigger === 'setParking') {
            this.setParking()
          } else if (trigger === 'updateParking') {
            this.updateParking()
          } else if (trigger === 'cancelParking') {
            this.cancelParking()
          } else if (trigger === 'closeToast') {
            this.delToast()
          } else if (trigger === 'cancelSetLayer') {
            this.closeLayer()
            this.delToast()
          }
        } else {
          this.addToast('closeToast', 'alert', this.locale.alert_system_error)
          this.delToast()
        }
      }
    },
    toastSetParking () {
      this.addToast('setParking', 'confirm', this.locale.confirm_regist_car_number)
    },
    async getFeatureParking () {
      return this.$store.dispatch('features/getFeatures').then((res) => {
        if (res && res.parking && res.parking.active) {
          this.limit = res && res.parking && res.parking.carLimit
          this.regist = res.parking.regist
          this.display = {
            ...this.display,
            ...res.parking.display
          }
        }
        return res && res.parking && res.parking.active
      })
    },
    setAuthentication () {
      const authentication = this.$store.getters['authentication/getAuthInfo']
      const siteid = authentication && authentication.site
      const spaceid = authentication && authentication.space
      const key = authentication && authentication.k
      const rid = authentication && authentication.rid
      const otaValid = this.isPublic || (authentication && authentication.otavalid !== 'false')
      this.auth = {
        siteid: siteid,
        spaceid: spaceid,
        key: key,
        otaValid: otaValid,
        ...rid && {
          rid: rid
        },
        result: siteid && (rid || (spaceid && key && otaValid))
      }
    },
    openLayer () {
      this.carNo = ''
      this.setLayer = true
    },
    closeLayer () {
      this.carNo = ''
      this.setLayer = false
      this.delToast()
    },
    cancelLayer () {
      this.addToast('cancelSetLayer', 'confirm', this.locale.confirm_cancel)
    },
    checkCarNoPattern (type) {
      // 특수문자는 입력불가
      const pattern = /[ \{\}\[\]\/?.,;:|\)*~`!^\-_+┼<>@\#$%&\'\"\\\(\=]/gi
      if (type === 'edit') {
        this.editCarNo = this.editCarNo.toString().replace(pattern, '')
      } else {
        this.carNo = this.carNo.toString().replace(pattern, '')
      }
    },
    getTimeFromFormat (iso) {
      const time = DateTime.fromISO(iso || moment().toISOString(), { zone: this.timezone })
      return time.toFormat(this.format)
    },
    async getParking () {
      const authentication = this.auth
      const siteid = authentication && authentication.siteid
      const spaceid = authentication && authentication.spaceid
      const key = authentication && authentication.key
      const rid = authentication && authentication.rid
      const otaValid = authentication && authentication.otaValid
      const data = otaValid && {
        siteid: siteid,
        spaceid: spaceid,
        key: key,
        ...rid && {
          rid: rid
        }
      }
      function getCarNo (str) {
        return `${str.slice(0, -4)} ${str.slice(-4)}`
      }
      if (otaValid) {
        this.$store.commit('loading', true)
        await this.$store.dispatch('guest/getParking', data).then((res) => {
          if (res) {
            if (res.status && res.status === 403) {
              if (res.message.code === 371) { // OTA 만료
                this.accessDenied = true
              }
              this.parkingApiError(res)
              this.active = false
            } else if (res.data) {
              const list = res.data.map(x => {
                return {
                  id: x.parkingId,
                  carNo: getCarNo(x.carNumber),
                  in: this.getTimeFromFormat(x.inCarDate),
                  out: this.getTimeFromFormat(x.outCarDate),
                  orderUUId: x.orderUUId,
                  ...x.areaInfo && {
                    floor: x.areaInfo.floor,
                    area: x.areaInfo.area
                  }
                }
              })
              this.list = list
              this.errStatus = null
            } else {
              this.addToast('closeToast', 'alert', this.locale.alert_system_error)
            }
            this.$store.commit('loading', false)
          } else {
            this.addToast('closeToast', 'alert', this.locale.alert_system_error)
            this.$store.commit('loading', false)
          }
        })
        this.$store.commit('loading', false)
      }
    },
    async getParkingSetting () {
      const authentication = this.auth
      const siteid = authentication && authentication.siteid
      const data = {
        siteid: siteid
      }
      if (siteid) {
        await this.$store.dispatch('guest/getParkingSetting', data).then((res) => {
          if (res) {
            if (res.status && res.status === 403) {
              this.parkingApiError(res)
            } else {
              this.parkingSetting = res
            }
          }
        })
      }
    },
    setParking () {
      const authentication = this.auth
      const siteid = authentication && authentication.siteid
      const spaceid = authentication && authentication.spaceid
      const key = authentication && authentication.key
      const otaValid = authentication && authentication.otaValid
      const langObj = this.$store.state.common.setting.lang.info
      const subject = function (langObj, val) {
        let obj = {}
        langObj.map(x => {
          obj[x.c] = val || ''
        })
        return obj
      }
      const submitData = {
        title: 'car number',
        info: {
          subject: subject(langObj, 'car number'),
          thumb: ''
        },
        submitAt: moment().toISOString(),
        submitId: 'system_parking',
        catCode: 'system_parking',
        categoryLabel: 'Parking',
        content: [
          {
            label: 'car number',
            type: 'parking',
            value: this.carNo
          }
        ]
      }
      const orderData = {
        catCode: 'system_room_service',
        payload: [submitData],
        userInfo: {
          ota: key,
          systemInfo: {}
        }
      }
      const data = otaValid && {
        siteid: siteid,
        spaceid: spaceid,
        key: key,
        data: orderData
      }
      this.$store.commit('loading', true)
      this.$store.dispatch('guest/setParking', data).then((res) => {
        if (res) {
          if (res === 'ok') {
            // this.addToast('closeToast', 'alert', this.locale.alert_complete_regist)
            this.errStatus = null
            this.closeLayer()
            this.getParking()
            this.$store.commit('loading', false)
          } else if (res.status && res.status === 403) {
            this.parkingApiError(res)
            this.$store.commit('loading', false)
          }
        } else {
          this.addToast('closeToast', 'alert', this.locale.alert_system_error)
          this.$store.commit('loading', false)
        }
      })
    },
    validateSave (type) {
      const status = type === 'edit' ? this.validateEditCarNo : this.validateCarNo
      if (status === 'empty') {
        this.addToast('closeToast', 'alert', this.locale.message_car_number_empty)
        return false
      } else if (status === 'pattern') {
        this.addToast('closeToast', 'alert', this.locale.message_car_number_pattern)
        return false
      }
      return true
    },
    async saveCarNo () {
      if (this.validateSave('regist')) {
        this.toastSetParking()
      }
    },
    openEditLayer (item) {
      this.editTarget = item
      this.editCarNo = item.carNo.replace(/\s/g, '')
      this.setEditLayer = true
    },
    closeEditLayer () {
      this.editTarget = null
      this.editCarNo = ''
      this.setEditLayer = false
    },
    saveEditCarNo () {
      if (this.validateSave('edit')) {
        this.addToast('updateParking', 'confirm', this.locale.confirm_edit_car_number)
      }
    },
    async updateParking () {
      const authentication = this.auth
      const siteid = authentication && authentication.siteid
      const rid = authentication && authentication.rid
      const data = {
        siteid: siteid,
        rid: rid,
        parkingId: this.editTarget.id,
        orderUUId: this.editTarget.orderUUId,
        carNumber: this.editCarNo
      }
      this.$store.commit('loading', true)
      await this.$store.dispatch('guest/updateParking', data).then((res) => {
        if (res) {
          this.errStatus = null
          if (res.status && res.status === 403) {
            this.parkingApiError(res)
            this.$store.commit('loading', false)
          } else {
            this.addToast('closeToast', 'alert', this.locale.alert_complete_edit || '수정이 완료되었습니다.')
            this.closeEditLayer()
            this.getParking()
          }
        } else {
          this.addToast('closeToast', 'alert', this.locale.alert_system_error)
        }
        this.$store.commit('loading', false)
      })
    },
    toastDeleteParking (item) {
      this.editTarget = item
      this.addToast('cancelParking', 'confirm', this.locale.confirm_delete_car_number)
    },
    async cancelParking () {
      const authentication = this.auth
      const siteid = authentication && authentication.siteid
      const rid = authentication && authentication.rid
      const data = {
        siteid: siteid,
        rid: rid,
        parkingId: this.editTarget.id,
        orderUUId: this.editTarget.orderUUId
      }
      this.$store.commit('loading', true)
      await this.$store.dispatch('guest/cancelParking', data).then((res) => {
        if (res) {
          if (res.status && res.status === 403) {
            this.parkingApiError(res)
            this.$store.commit('loading', false)
          } else {
            this.addToast('closeToast', 'alert', this.locale.alert_complete_delete || '삭제가 완료되었습니다.')
            this.getParking()
          } 
        } else {
          this.addToast('closeToast', 'alert', this.locale.alert_system_error)
        }
        this.$store.commit('loading', false)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  & > .inner {
    max-width: 400px;
  }
  .inputBox {
    position: relative;
  }
  .pass {
    position: absolute;
    top: 50%;
    right: 4px;
    width: 24px;
    height: 24px;
    margin-top: -12px;
    border-radius: 100%;
    background: $color-green url('~@/assets/img/ico_checked.svg') 50% 50% / 12px no-repeat;
  }
}
.btnAdd {
  width: 100%;
  margin-bottom: 5px;
  padding: 15px 10px;
  color: $color-lgrey;
  border-radius: 8px;
  border: 1px solid $color-lgrey2;
}
.message {
  font-size: 14px;
}
.parkingInfo {
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
  padding: 30px;
  font-family: 'Pretendard', 'Noto Sans', sans-serif;
  border: 1px solid $color-lgrey2;
  border-radius: 8px;
  .infoContent {
    flex: 1;
  }
  .infoBtns {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 20px;

  }
  dl {
    margin-bottom: 15px;
  }
  dt {
    color: $color-grey;
  }
  dd {
    font-size: 20px;
    vertical-align: middle;
  }
  .areaInfo {
    i {
      margin-right: 0.3em;
    }
  }
  .carNo {
    display: inline-block;
    margin-right: 15px;
    vertical-align: middle;
  }
  .btn {
    font-size: 16px;
    border-radius: 8px;
  }
}
.noData {
  padding: 40px 15px 60px;
  font-size: 20px;
  text-align: center;
  color: $color-grey;
}

@media screen and (max-width: 767px) {
  .infoBtns .btn {
    font-size: 14px;
    padding: 0.6em 15px;
  }
}
</style>
